import { Component, OnInit, Inject, Input, OnDestroy, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Validators, FormBuilder, AbstractControl } from '@angular/forms';

import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'shared-form-for-adyen-cvv',
    templateUrl: './form-for-adyen-cvv.shared.component.html',
    styleUrls: ['./form-for-adyen-cvv.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormForAdyenCVVComponent extends FormTypesComponent implements OnInit, AfterViewInit, OnDestroy {
    public hint = {
        feel: 'danger',
        size: 'sm',
        vside: 'center',
        hside: 'right',
    };

    public fieldsStatus: Partial<Record<Adyen.FieldInputTypes, OLO.Components.IMappedMessage>> = {
        encryptedSecurityCode: null
    };

    public touched: Partial<Record<Adyen.FieldInputTypes, boolean>> = {
        encryptedSecurityCode: false
    };

    private _isValid: boolean = false;
    private _adyenEncryptedPaymentData: Adyen.PaymentData = null;
    @ViewChild('formWrapper', { static: false }) public container!: ElementRef<HTMLDivElement>;

    public adyenConfigState$: Observable<State.AdyenLocationConfig>;
    public isMakingRequests$: Observable<boolean>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
        public membersService: Services.MembersService,
        public modalsService: Services.ModalsService,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super(config, formBuilder);
        this.formName = 'adyen-cvv';
    }

    ngOnInit(): void {
        this.controllers.creditCards.initAdyen();

        this.adyenConfigState$ = this.controllers.creditCards.getAdyenConfig$();
        this.isMakingRequests$ = this.controllers.creditCards.isMakingRequests$();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            const target = this.container?.nativeElement || `#${this.formName}`;

            this.controllers.payment.initAdyenForm(target, {
                onChange: (state, reactComponent) => {
                    this._isValid = state.isValid;

                    this._adyenEncryptedPaymentData = Object.keys(state.data.paymentMethod).reduce((paymentData, key) => {
                        if(key === 'type') {
                            return paymentData;
                        }

                        return {
                            ...paymentData,
                            [key]: state.data.paymentMethod[key]
                        };
                    }, {} as Adyen.PaymentData);

                    this.changeDetectorRef.detectChanges();
                },
                onBinValue: ({ binValue }) => {

                },
                onError: (errorObj) => {
                    this._updateFieldStatus(errorObj.fieldType, errorObj.error && {
                        key: errorObj.i18n,
                        message: errorObj.i18n,
                        messageType: 'danger',
                    } || null);
                },
                onFieldValid:(validObj) => {
                    this._updateFieldStatus(validObj.fieldType, null);
                }
            });

            this.onInit.emit(null);
        }, 0);
    }

    ngOnDestroy(): void {
        this.controllers.payment.destroyAdyenForm();
    }

    public handleFormSubmit($event: Event): void {
        $event.preventDefault();
    }

    public get isValid(): boolean {
        return this._isValid;
    }

    public handleOnSubmit($event: Event): void {
        this.controllers.onlineOrders.placeOrderWithAdyenCVVCode(this._adyenEncryptedPaymentData.encryptedSecurityCode);

        this.onFormSubmit.emit({ event:$event, form: null });
    }

    protected _setTouched(fieldType: Adyen.FieldInputTypes): void {
        this.touched[fieldType] = true;
    }

    protected _updateFieldStatus(fieldType: Adyen.FieldInputTypes, error: OLO.Components.IMappedMessage): OLO.Components.IMappedMessage {
        this._setTouched(fieldType);

        for(const key in this.fieldsStatus) {
            if(key !== fieldType) {
                this.fieldsStatus[key] = null;
            }
        }

        this.fieldsStatus[fieldType] = error;
        this.changeDetectorRef.detectChanges();

        return error;
    }
}
